import { render, staticRenderFns } from "./hierarchy-component.vue?vue&type=template&id=ed3609f0&scoped=true"
import script from "./hierarchy-component.ts?vue&type=script&lang=ts&external"
export * from "./hierarchy-component.ts?vue&type=script&lang=ts&external"
import style0 from "./hierarchy-component.scss?vue&type=style&index=0&id=ed3609f0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3609f0",
  null
  
)

export default component.exports